module.exports = __webpack_public_path__ + "img/woman-couch-tablet.ce47a112.jpg";